module.exports = __webpack_public_path__ + "img/bg-grass.fdef4522.png";